module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Light Gray.de8ba4c6.png";